import Debug from 'debug';
const debug = Debug(`knack.core.helpers.filters.createSingleFilter`);
export const createSingleFilter = (match, field, operator, value, range = ``, type = ``) => {
    return {
        match,
        rules: [
            {
                field,
                operator,
                value,
                type,
                range
            }
        ]
    };
};
